module.exports = __webpack_public_path__ + "img/animals.b0a85dba.png";